<template>
  <TextField
    inputId="cashless-pay-name"
    name="name"
    :label="t('sites.singleSite.financialConfig.cashlessPay.form.name')"
    :placeholder="t('sites.singleSite.financialConfig.cashlessPay.form.namePlaceholder')"
    :required="editCashlessPay"
    :disabled="!editCashlessPay"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editCashlessPay } = storeToRefs(fConfigStore);
</script>
